import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    container: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: Theme.primaryBackgroundColor,
        padding: 0,
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    miniContainer: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        height: '14%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        flexDirection: 'row',
        width: '100%',
        zIndex: 665
    },
    videoPlayer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        flex: 1,
        alignSelf: 'stretch'
    },
    miniVideoPlayer: {
        height: '100%',
        flex: 4
    },
    miniPlayerDetail: {
        flex: 5
    },
    landscapeMiniPlayerContainer: {
        right: 0,
        width: '45%',
        height: '23%'
    },
    videoScreen: {
        left: 0,
        right: 0,
        bottom: 0,
        top: 0
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        miniContainer: {
            position: 'absolute',
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            bottom: '3%',
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            right: '3%',
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            height: 120,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            flexDirection: 'row',
            width: '50%',
            maxWidth: 450,
            borderWidth: 1,
            borderColor: Theme.secondaryTextColor
        }
    };
}

export default StyleSheet.create(baseStyles as any);
